import Login from "../Login/Login";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import CaseListing from "../pages/case-study/CaseListing";
import CaseCreate from "../pages/case-study/CaseCreate";
import CaseEdit from "../pages/case-study/CaseEdit";
// import TrackingCode from "../pages/Tracking/TrackingCode";
import SeoEdit from "../pages/Seo/SeoEdit";
import CaseCategory from "../pages/casecategory/Casecategory";
import JobPostingListing from "../pages/jobPosting/JobPostingListing";
import AddJobPosting from "../pages/jobPosting/AddJobPosting";
import Location from "../pages/location/Location";
import Experience from "../pages/experience/Experience";
import Operation from "../pages/operation/operation";
import EditJobPosting from "../pages/jobPosting/EditJobPosting";
import LocationPageListing from "../pages/locationpage/LocationPageListing";
import AddLocationPage from "../pages/locationpage/AddLocationPage";
import EditLocationPage from "../pages/locationpage/EditLocationPage";
import JobApplications from "../pages/jobApplications/JobApplications";
import Newsletters from "../pages/newsletters/Newsletters";
import PressListing from "../pages/pressRelease/PressListing";
import AddPress from "../pages/pressRelease/AddPress";
import EditPress from "../pages/pressRelease/EditPress";
import ServicesForm from "../pages/ServicesForm/ServicesForm";
import AiBlogs from "../pages/aiBlogs/AiBlogs";
import AddAiBlog from "../pages/aiBlogs/AddAiBlog";
import EditAiBlog from "../pages/aiBlogs/EditAiBlog";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import LlmsEditor from "../pages/Llms/LlmsEditor";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";



export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          
          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />

          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />

          <Route path="ai-blog" element={<AiBlogs />} />
          <Route path="add-ai-blog" element={<AddAiBlog />} />
          <Route path="edit-ai-blog/:aiblog_id" element={<EditAiBlog />} />
          {/* press */}
          <Route path="press" element={<PressListing />} />
          <Route path="add-press" element={<AddPress />} />
          <Route path="edit-press/:press_id" element={<EditPress />} />
          
          <Route path="contact" element={<Contact />} />
          <Route path="service-form" element={<ServicesForm />} />
          <Route path="job-applications" element={<JobApplications />} />
          <Route path="newsletters" element={<Newsletters />} />

          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          <Route path="llms" element={<LlmsEditor />} />
          <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />

          {/* <Route path="tracking-code" element={<TrackingCode/>} /> */}

          <Route path="case-category" element={<CaseCategory />} />

          <Route path="case" element={<CaseListing />} />
          <Route path="add-case" element={<CaseCreate />} />
          <Route path="edit-case/:case_id" element={<CaseEdit />} />

          <Route path="jobpost" element={<JobPostingListing />} />
          <Route path="add-jobpost" element={<AddJobPosting />} />
          <Route path="edit-jobpost/:job_id" element={<EditJobPosting />} />

          <Route path="experience" element={<Experience />} />
          <Route path="location" element={<Location />} />
          <Route path="operation" element={<Operation />} />

         <Route path="location-page" element={<LocationPageListing />} />
        <Route path="add-locationpage" element={<AddLocationPage />} />
         <Route path="edit-locationpage/:locpage_id" element={<EditLocationPage />} />

          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />


        </Route>
      </Routes>
    </>
  )
}
